import React from 'react';

const VisionImpactSection = ({
  heading = 'Vision & Impact',
  mission = 'Our mission is to make Ethiopia —and East Africa— a hub for entrepreneurial excellence. By strengthening each coaching session and each program we touch, we build ecosystems that create jobs, innovation, and hope.',
  quote = 'Yomuma and his team don’t just coach startups—they build the systems that make coaching work.',
  author = 'Yomuma Likessa Daba, Founder & Ecosystem Architect',
  imageSrc = '/image_5.jpeg'
}) => {
  return (
    <section className="bg-white py-16 lg:py-20 w-full">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-14">
          {/* Image */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-start">
            <img
              src={imageSrc}
              alt="Yomuma Likessa"
              className="w-full max-w-md h-auto rounded-3xl object-contain shadow-lg"
              loading="lazy"
            />
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2 space-y-6">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
              {heading}
            </h2>

            <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
              {mission}
            </p>

            <blockquote className="border-l-4 border-accent-yellow pl-4 sm:pl-6 text-gray-800 italic text-lg sm:text-xl leading-relaxed">
              &ldquo;Yomuma and his team don’t just coach startups—they build the systems that make coaching work.&rdquo;
            </blockquote>

            <p className="text-gray-600 font-semibold text-base sm:text-lg">
              — {author}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionImpactSection;

